<template>
<div class="coupon-wrap">
	<el-popover
		v-if="couponList.length>2"
		placement="top-start"
		width="240"
		popper-class="heightauto"
		trigger="hover">
		<span
			v-for="(item, i) in couponList"
			:key="i"
			:class="['tag', couponType(item).color]"
			><span class="type">{{ couponType(item).type }}</span
			>满{{ item.fullPrice }}减{{ item.reductionPrice }}</span
		>
		<div slot="reference" class="pointer">
			<span
				:class="['tag', couponType(item).color]"
				v-for="(item, i) in couponList"
				:key="i"
				v-show="i<2"
				>
				<span class="type">{{ couponType(item).type }}</span
				>{{item.tagName}}
			</span>
		</div>
	</el-popover>
	<div class="couponList" v-else>
		<span
			:class="['tag', couponType(item).color]"
			v-for="(item, i) in couponList"
			:key="i"
			v-show="i<2"
			>
			<span class="type">{{ couponType(item).type }}</span
			>{{item.tagName}}
		</span>
	</div>
</div>
</template>
<script>
export default {
	props:{
		couponList:{
			type:Array,
			default:()=>{
				return []
			}
		}
	},
	methods:{
		couponType(value) {
			let couponType = Number(value.couponsType);
			let itemType = {
					color: 'orange',
					type: '店铺'
			}
			if (couponType === 2) {
				return (itemType = {
					color: 'orangered',
					type: '活动'
				});
			} else if (couponType === 3) {
				itemType = {
					color: 'purple',
					type: '预售'
				};
			}
			return itemType;
		},
	}
}
</script>
<style lang="scss" scoped>
	.pointer{
		cursor: pointer;
	}
	.tag {
		display: inline-block;
		margin-top: 4px;
		margin-left: 2px;
		color: #fff;
		padding: 0 10px;
		height: 18px;
		font-size: 12px;
		line-height: 18px;
		text-align: center;

		.type {
			padding-right: 4px;
			padding-left: 0;
		}

		&.orange {
			background: url('https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572488947463.png') no-repeat;
		}

		&.orangered {
			background: url('https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572488951496.png') no-repeat;
		}

		&.purple {
			border: 1px solid #a43ca4;
			color: #a43ca4;
		}
	}
</style>